/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".italicText[_ngcontent-%COMP%]{font-style:italic}.blueText[_ngcontent-%COMP%]{color:#005cab}.greenText[_ngcontent-%COMP%]{color:#090}"];
export { styles as styles };
